import React, {useEffect} from "react"
import "../Styles/NotFound.css"
import { useNavigate } from "react-router-dom";
import Navbar from "../Components/Navbar/Navbar";
import Color from "../Components/Colors/Color";
import { useStateContext } from "../Contexts/productsCardContext";

const PageNotFound = () =>{

    const {setPage} = useStateContext();

    useEffect(() => {
        setPage('other')
        
        window.scrollTo(0,0);
      }, [])
    

    const navigate = useNavigate();

    const handlePreviousPage = () => {
        navigate("");
    }
    
    return (
        <div className="not-found-page" style={{backgroundColor: Color.primaryBackground}}>
            <Navbar />

            <div className="not-found-content" style={{backgroundColor: Color.primaryBackground, color: Color.secondaryText}}>
                <h1 className="not-found-h1"> 404 - Page not found </h1>
                <h4 className="not-found-h2">The page you are looking for doesn't exist!</h4>
            </div>
        </div>
    )
  }
  export default PageNotFound;